export default {
  textToSpeech: {
    onLabel: 'Disable text to speech',
    offLabel: 'Enable text to speech',
    error:
      'Encountered an error with the text to speech! Please try again after some time.',
  },
  speechToText: {
    offLabel: 'Click mic icon and speak',
    onLabel: 'Listening...',
    loadingLabel: 'Connecting...',
    error:
      'Encountered an error with the microphone! Please try switching to keyboard mode.',
    permissionDeniedError:
      'Permission denied to use microphone! Please try switching to keyboard mode.',
  },
  progress: 'Progress',
  completionMessage:
    'Patient has already completed this conversation with forms and medications.',
  responseError: 'There was an error generating a response',
  emptyMessageWarning: 'Please add a message to send',
  edit: 'Edit',
  regenerateResponse: 'Regenerate Response',
  controls: {
    placeholder: 'Type here to add your response',
    send: 'Send',
  },
  feedback: {
    submitSuccess: 'Feedback submitted!',
    submitError: 'Failed to submit feedback',
  },
  chatCompletion: {
    error:
      "Failed to complete the chat! Don't worry, your data is still saved with us!",
    chat: {
      successMessage:
        'Thank you for completing the conversation. To ensure your privacy and confidentiality, please click the Logout button below.',
    },
    form: {
      successMessage:
        'Thank you for completing the form. To ensure your privacy and confidentiality, please click the Logout button below.',
    },
    logoutButton: 'Logout',
  },
};
